import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary';
import { reportClientError } from './utils/api';
import reportWebVitals from './reportWebVitals';

window.addEventListener('error', (event) => {
  reportClientError(event.error || event.message, { source: 'window.error' });
});

window.addEventListener('unhandledrejection', (event) => {
  reportClientError(event.reason || 'Unhandled promise rejection', { source: 'unhandledrejection' });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
